import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';

import * as ApiConfig from '../core/apiconfig';
import * as Model from './index.model';
import * as SharedModel from '../core/index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class CitService {
    private apiUrl: string;
    public profileInfo: SharedModel.ProfileInfo;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http) {
        this.apiUrl = ApiConfig.API_URL;
    }

    //Get CitService Details
    getServiceDetails(CitizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_GetServiceDetails + "/" + CitizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Model.CitService;
            })
            .catch(this.handleError);
    }

    CreateServiceRequest(model: Model.CitService) {

        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http.post(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_ServiceRequest, body, this.Http_Header_Request_Options)
            .toPromise().then(data => { return data.json() as Model.CitService; });
    }

    // Post the HouseCheckInsert Form Data to Api
    HouseCheckInsert(model: Model.CitService) {

        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http.post(this.apiUrl + ApiConfig.API_HouseCheck + "/" +ApiConfig.API_HouseCheckInsert , body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }



    // Put the HouseCheckInsert Form Data to Api notes: string, citiserviceId: string
    CitServiceHistUpdate(model: Model.CitServiceHistUpdate) {

        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http.put(this.apiUrl + ApiConfig.API_HouseCheck, body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Post the Anonymous Tips Form Data to Api
    CreateAnonymousTips(model: Model.CitService): Promise<Model.CitService> {
        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http.post(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_AnonymousTips, body, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as Model.CitService)
            .catch(this.handleError);
    }

    //Get CitServiceHist Details Start
    getcitServiceHist(CitizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http
            .get(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_GetServiceDetails + "/" + CitizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Model.CitService;
            })
            .catch(this.handleError);
    }
    //Get HouseCheck Details Start
    getHouseCheckService(CitizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http
            .get(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_HouseCheckService + "/" + CitizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Model.CitService;
            })
            .catch(this.handleError);
    }
    // Get CitServiceHist Details End

    // Get  the HouseCheck History based on citServiceId to Api Start
    ViewHouseCheckHistory(CitServiceId: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_HouseCheckHistory + "/" + CitServiceId, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Model.CitService;
            })
            .catch(this.handleError);
    }

    // Get  the HouseCheck History based on nameID to Api Start
    ViewHouseCheckHistorybynameID(nameID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_HouseCheckHistoryByNameID + "/" + nameID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Model.CitService;
            })
            .catch(this.handleError);
    }

    //Get GetCitizenInfo Details Start
    getCitizenInfo(CitizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_GetCitizenInfo + "/" + CitizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                if (response.json()[0]) {

                    this.profileInfo = {
                        CitizenID: (response.json()[0].CitizenID !== null ? response.json()[0].CitizenID : ""),
                        JurisID: (response.json()[0].JurisID !== null ? response.json()[0].JurisID : ""),
                        FirstName: (response.json()[0].FirstName !== null ? response.json()[0].FirstName : ""),
                        LastName: (response.json()[0].LastName !== null ? response.json()[0].LastName : ""),
                        MiddleName: (response.json()[0].MiddleName !== null ? response.json()[0].MiddleName : ""),
                        Email: (response.json()[0].Email !== null ? response.json()[0].Email : ""),
                        PrimaryNumber: (response.json()[0].PrimaryNumber !== null ? response.json()[0].PrimaryNumber : ""),
                        AlternateNumber: (response.json()[0].AlternateNumber !== null ? response.json()[0].AlternateNumber : ""),
                        Address1: (response.json()[0].Address1 !== null ? response.json()[0].Address1 : "")
                    }                 

                }
                return this.profileInfo;
            })
            .catch(this.handleError);
    }
    // Get GetCitizenInfo Details End

    //Get GetAddress Details Start
    getAddress(CitizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_HouseCheck + "/" + ApiConfig.API_GetAddress + "/" + CitizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                if (response.json()[0]) {

                  

                }
                return response.json() as SharedModel.AddressInfo;
            })
            .catch(this.handleError);
    }
    // Get GetAddress Details End
    GetIncidentIncidentCSFCodeTypes(JurisID: string, CodeID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_GetCodedValues + "/" + JurisID + "/" + CodeID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as SharedModel.CodeValue)
            .catch(this.handleError);
    }


    GetCitizenAddressInfo(citizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_Citizen + "/" + citizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json()[0];
            })
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/services/housecheck.service.ts